export function bandColor(band) {
  return (
    {
      Sinking: "#8A817C",
      Floating: "#DDA15E",
      Advancing: "#FF8A00",
      Compounding: "#FF4D4D",
    }[band] || "#FF8A00"
  );
}

export function bandFromScore(score) {
  if (score <= 40) return "Sinking";
  if (score <= 65) return "Floating";
  if (score <= 85) return "Advancing";
  return "Compounding";
}
